export default "/assets/bcac608d3069ec6f.png"